import { ComponentType } from 'react'

import { BathSvg, BedSvg, CarSvg, PowderSvg, StudySvg } from '@svg/react'
import { SvgProps } from '@svg/react/types'

import { Configurations } from '@adUtilities/types/common'

interface UnitConfigurationItem {
  key: keyof Configurations
  title: string
  Icon: ComponentType<SvgProps>
}

export const TAP_MAX_POINTER_TRAVEL = 5

export const UNITS_PANEL_TOGGLE_DURATION = 300

export const DEFAULT_STATUS_COLOUR = '#EF4444'

export const SOLD_OUT_LABEL = 'Sold out'

export const NO_MATCH_LABEL = 'No match'

export const FILTER_MATCH_LABEL = 'match your filters'

export const UNIT_CONFIGURATIONS: UnitConfigurationItem[] = [
  { key: 'bed', title: 'Bed', Icon: BedSvg },
  { key: 'study', title: 'Study', Icon: StudySvg },
  { key: 'bath', title: 'Bath', Icon: BathSvg },
  { key: 'powderRoom', title: 'Powder', Icon: PowderSvg },
  { key: 'car', title: 'Car', Icon: CarSvg },
]
